module.exports = __webpack_public_path__ + "img/eski çeşme.8114c4ff.png";